import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface ErrorDetailsDialogProps {
    open: boolean;
    onClose: () => void;
    failedRecords: Array<{
        reason?: string;
        [key: string]: any;
    }>;
    successCount: number;
    failCount: number;
}

export const ErrorDetailsDialog: React.FC<ErrorDetailsDialogProps> = ({
    open,
    onClose,
    failedRecords,
    successCount,
    failCount
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="md" 
            fullWidth
            scroll="paper"
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="div">
                    导入结果详情
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {/* 统计信息 */}
                <Box sx={{ mb: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                    <Typography variant="body1" gutterBottom>
                        <strong>导入统计:</strong>
                    </Typography>
                    <Typography variant="body2" color="success.main">
                        成功: {successCount} 条
                    </Typography>
                    <Typography variant="body2" color="error.main">
                        失败: {failCount} 条
                    </Typography>
                </Box>

                {/* 错误详情 */}
                {failedRecords && failedRecords.length > 0 ? (
                    <Box>
                        <Typography variant="body1" gutterBottom>
                            <strong>失败详情:</strong>
                        </Typography>
                        <Box 
                            component="pre" 
                            sx={{ 
                                whiteSpace: 'pre-wrap',
                                backgroundColor: '#fff9f9',
                                p: 2,
                                borderRadius: 1,
                                border: '1px solid #ffcdd2',
                                maxHeight: '400px',
                                overflow: 'auto',
                                fontSize: '0.875rem'
                            }}
                        >
                            {failedRecords.map((record, index) => (
                                <Typography 
                                    key={index} 
                                    variant="body2" 
                                    color="error"
                                    component="div"
                                    sx={{ mb: 1 }}
                                >
                                    {index + 1}. {record.reason || '未知错误'}
                                    {record.field && ` (${record.field})`}
                                    {record.rowNum && ` - 第${record.rowNum}行`}
                                </Typography>
                            ))}
                        </Box>
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        没有失败记录
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    variant="contained" 
                    color="primary"
                >
                    关闭
                </Button>
            </DialogActions>
        </Dialog>
    );
};